<template>
    <div class="container" style="min-height: calc(100vh - 40px);">

        <div style="height: 4em"></div>

        <div class="head-box dark">
            <h1 style="padding-top:10px">{{ $t('head_downloads') }}</h1>
        </div>

        <div style="height:1em;"></div>

        <div class="dl-box" style="max-width: 800px;margin-top:15px;border-radius:25px">
            <button class="ui-btn ui-green" data-toggle="collapse" data-target="#officalversion" aria-expanded="true" aria-controls="collapseOne" style="margin:20px 0px 10px 0px;"><b>{{ $t('stable_version') }}</b></button>
            <button class="ui-btn ui-red" data-toggle="collapse" data-target="#betaversion" aria-expanded="true" aria-controls="collapseOne" style="margin:20px 0px 10px 1%;"><b>{{ $t('beta_version') }}</b></button>
        </div>

<div id="accordion">
    <div id="officalversion" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion" v-for="(text, index) in downloads_data_stable" :key="index">
        <!--start-->
        <div style="margin-top:5%">
            <div class="dl-box" style="max-width: 740px">
                <div style="padding: 0 0.976em">
                    <h2 align="center"  style="margin-top:10px"><b>{{ text.version }}</b></h2>
                    <p><span class="badge badge-pill" :class="`badge-${text.badge_type}`">{{ text.badge }}</span></p>
                    <p><span class="badge badge-info" v-html="text.update_time"></span></p>
                    <h5 align="center">{{ text.description }}</h5>
                    <div class="d-flex">
                        <button class="ui-btn ui-green" data-toggle="modal" :data-target="`#${text.target_value}`"><b>{{ $t('view_more' )}}</b></button>
                        <a class="ui-btn ui-blue ml-auto" :href="text.downlaod_link"><b>{{ $t('download' )}}</b></a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 版本資訊-->
        <div class="modal fade" :id="text.target_value" tabindex="-1" role="dialog" aria-labelledby="'.$text->version.'" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content msg-box">
                <div class="modal-header">
                    <h5 class="modal-title" id="'.$text->version.'">關於 {{ text.version }} 版本資料</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <h1 style="text-align:center;">{{ text.version }}</h1>
                    <p style="text-align:center;" v-html="text.update_time"></p>
                    <h3><b>{{$t('new_feature')}}</b></h3>
                    <span v-for="(info, s_index) in text.information.feature" :key="s_index">
                        <p>{{ info }}</p>
                    </span>
                    <h3><b>{{$t('fix_bug')}}</b></h3>
                    <span v-for="(info, s_index) in text.information.fix" :key="s_index">
                        <p>{{ info }}</p>
                    </span>
                    <h3><b>{{$t('other_update')}}</b></h3>
                    <span v-for="(info, s_index) in text.information.other" :key="s_index">
                        <p>{{ info }}</p>
                    </span>

                </div>
                <div class="modal-footer">
                    <button type="button" class="ui-btn ui-green" data-dismiss="modal" style="border:0px">{{ $t('close' )}}</button>
                </div>
                </div>
            </div>
        </div>
        <!--end-->
    </div>

    <div id="betaversion" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion" v-for="(text, index) in downloads_data_beta" :key="index">
        <!--start-->
        <div style="margin-top:5%">
            <div class="dl-box" style="max-width: 740px">
                <div style="padding: 0 0.976em">
                    <h2 align="center"  style="margin-top:10px"><b>{{ text.version }}</b></h2>
                    <p><span class="badge badge-pill" :class="`badge-${text.badge_type}`">{{ text.badge }}</span></p>
                    <p><span class="badge badge-info" v-html="text.update_time"></span></p>
                    <h5 align="center">{{ text.description }}</h5>
                    <div class="d-flex">
                        <button class="ui-btn ui-green" data-toggle="modal" :data-target="`#${text.target_value}`"><b>{{ $t('view_more' )}}</b></button>
                        <a class="ui-btn ui-blue ml-auto" :href="text.downlaod_link"><b>{{ $t('download' )}}</b></a>
                    </div>
                </div>
            </div>
                <!-- 版本資訊-->
                <div class="modal fade" :id="text.target_value" tabindex="-1" role="dialog" aria-labelledby="'.$text->version.'" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content msg-box">
                        <div class="modal-header">
                            <h5 class="modal-title" id="'.$text->version.'">關於 {{ text.version }} 版本資料</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <h1 style="text-align:center;">{{ text.version }}</h1>
                            <p style="text-align:center;" v-html="text.update_time"></p>
                            <h3><b>新功能</b></h3>
                            <span v-for="(info, s_index) in text.information.feature" :key="s_index">
                                <p v-html="info"></p>
                            </span>
                            <h3><b>漏洞修復</b></h3>
                            <span v-for="(info, s_index) in text.information.fix" :key="s_index">
                                <p v-html="info"></p>
                            </span>
                            <h3><b>其他更新</b></h3>
                            <span v-for="(info, s_index) in text.information.other" :key="s_index">
                                <p v-html="info"></p>
                            </span>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="ui-btn ui-green" data-dismiss="modal" style="border:0px">{{ $t('close' )}}</button>
                        </div>
                        </div>
                    </div>
                </div>
                <!--end-->
            </div>
        </div>

            <div style="height:1em;"></div>

        </div>
    </div>
</template>

<script>
//import downloads_api from '../../public/api/tw/downloads.json'

export default {
    data () {
        return {
            downloads_data_beta: null,
            downloads_data_stable: null
        }
    },
    watch: {
        "$i18n.locale": function (lang) {
            // eslint-disable-next-line
            axios.get('/api/' + lang + '/downloads.json')
            .then((response) => {
                this.downloads_data_beta = response.data.beta;
                this.downloads_data_stable = response.data.stable;
            })
        }
    },
    mounted () {
        var lang = this.$i18n.locale

        if(lang === null){
            lang = 'en'
        }

        // eslint-disable-next-line
        axios.get('/api/'+lang+'/downloads.json')
        .then((response) => {
            this.downloads_data_beta = response.data.beta;
            this.downloads_data_stable = response.data.stable;
        })
    }
}
</script>